const personalSettings = {
  title: "Personal Settings",
  backLabel: "Settings",
  sections: {
    personalDetails: {
      title: "Personal details",
      subtitle: "Here you can manage your profile details",
      avatar: "Avatar",
      firstName: "First name",
      lastName: "Last name",
      password: "Password",
      email: "Email",
      edit: "Edit",
      cancel: "Cancel",
      save: "Save",
      saving: "Saving...",
      changePassword: "Change password",
      addPhoto: "+ Add photo",
      change: "Change",
      remove: "Remove",
      uploadProfilePicture: "Upload profile picture",
      profile: "Profile",
    },
    twoFactor: {
      title: "Two-step authentication",
      activated: "Activated",
      subtitle: "Enabling this will provide an extra layer of security for your account. When logging in, we will ask for a special authentication code from your device.",
      enable: "Enable Two-factor authentication",
      disable: "Disable Two-factor authentication",
      enabling: "Enabling...",
    },
    emailNotifications: {
      title: "Email Notifications",
      monthlyNewsletter: {
        title: "Monthly newsletter",
        subtitle: "Get a monthly email with product news, updates, and tips",
      },
      notifications: {
        title: "Notifications",
        subtitle: "Receive important alerts about your account and activity",
      },
      supportUpdates: {
        title: "Support updates",
        subtitle: "Get updates about your support requests and responses",
      },
    },
    language: {
      title: "Language",
      english: "English",
      spanish: "Español",
      french: "Français",
      german: "Deutsch",
      italian: "Italiano",
    },
  },
  messages: {
    personalDetailsChanged: "Personal details were changed!",
    personalDetailsFailed: "Failed to save personal details",
    passwordChanged: "Password has been changed",
    passwordChangeFailed: "Failed to change password. Please try again.",
    twoFactorEnabled: "Two-factor authentication enabled",
    twoFactorDisabled: "Two-factor authentication turned off",
    twoFactorDisableFailed: "Failed to disable two-factor authentication. Please try again.",
    emailCodeFailed: "Failed to send email code. Please try again.",
    wrongCode: "Wrong code. Try again.",
    invalidCode: "Invalid verification code. Try again.",
    setupFailed: "Setup failed. Please try again.",
    secretNotAvailable: "Secret not available",
  },
  modals: {
    checkEmail: {
      title: "Check your email",
      sentCode: "We've sent a verification code to:",
      enterCode: "Enter your code",
      oneTimeCode: "One-time code",
      resendCode: "Resend code",
      resendIn: "Resend code in",
      sending: "Sending...",
      cancel: "Cancel",
      continue: "Continue",
      verifying: "Verifying...",
      authenticatorApp: "Authenticator app",
    },
    connectAuthApp: {
      title: "Connect your authentication app",
      step1: "Step 1",
      step1Text: "You need a two-factor authentication application to scan the QR code and generate codes when you are asked during login. We recommend Google Authenticator, available on the",
      appleAppStore: "Apple App Store",
      or: "or",
      googlePlay: "Google Play",
      step2: "Step 2",
      step2Scan: "Scan the QR code in the authentication app, then enter the 6-digit code from the app.",
      step2Manual: "Enter the secret code provided below in the authentication app, and then enter the 6-digit code from the app.",
      cantScan: "Can't scan?",
      loading: "Loading...",
      copy: "Copy",
      copied: "Copied",
      showQRCode: "Show QR-Code",
      next: "Next",
      verification: "Verification",
      enterCode: "Enter your 6-digits code that you see in the app",
      sixDigitsCode: "6-digits code",
      back: "Back",
      verify: "Verify",
      verifying: "Verifying...",
    },
    setNewPassword: {
      title: "Set up new password",
      description: "Use at least 8 characters, including a number or symbol",
      newPassword: "New password",
      enterNewPassword: "Enter new password",
      confirmNewPassword: "Confirm new password",
      cancel: "Cancel",
      setUp: "Save",
    },
    verificationRequired: {
      title: "Verification required",
      description: "Enter the 6-digit verification code generated by your authenticator app",
      enterCode: "Enter code",
      cancel: "Cancel",
      continue: "Continue",
      verifying: "Verifying...",
    },
    disableTwoFactor: {
      title: "Disable two-factor authentication",
      verifyIdentity: "Verify your identity",
      verifyText: "Check if the code is in the app for the one-time password you are using",
      enterCode: "Enter your code",
      oneTimeCode: "One-time code",
      sendToEmail: "Send the code to my email",
      cancel: "Cancel",
      continue: "Continue",
      verifying: "Verifying...",
    },
    disableTwoFactorConfirm: {
      title: "Disable two-factor authentication",
      description: "By removing the authentication app, you will not be able to use the codes from it to log in",
      cancel: "Cancel",
      disable: "Disable",
      disabling: "Disabling...",
    },
  },
  validation: {
    codeRequired: "Code must be 6 digits.",
    codeMustBe6Digits: "Code must be 6 digits.",
    passwordRequired: "Password is required.",
    passwordMinLength: "Use at least 8 characters.",
    passwordDigitOrSymbol: "Include a number or symbol.",
    confirmPasswordRequired: "Confirm password is required.",
    passwordsDoNotMatch: "Passwords do not match.",
  },
};

export default personalSettings;
